<template>
    <v-card outlined max-width="600px" class="mx-auto pa-6 pa-sm-10 mt-6 mb-12 border-top-left-radius:0; border-top-right-radius:0;">
        <form id="subscription-form">
            <div v-if="loaded">
				<v-btn text class="grey--text mt-n6" @click="$router.push('/subscription')">
					<v-icon size="12" color="grey" class="mr-2 ml-n3">fa-arrow-left</v-icon>
					Back
				</v-btn>
				<div class="display-1 primary--text">3 Steps Online World</div>
				<div class="headline">Monthly Subscription</div>
				<div class="title primary--text">
					$12.99 USD
				</div>
				<div class="caption grey--text text--darken-1">
					- CANCEL ANYTIME - 
				</div>
				<div class="mt-4 pl-3">
					<span class="body-2 grey--text text--darken-1">Name:</span>
					<span class="ml-2 font-weight-medium">{{customer.parentName}}</span>
				</div>
            </div>

            
            <div id="card-element" ref="cardelement" class="MyCardElement pa-3 camp mt-2 mb-1">
                <!-- Elements will create input elements here -->
            </div>

            <!-- We'll put the error messages in this element -->
            <div id="card-errors" ref="carderrors" role="alert" class="caption mb-3"></div>

            <v-btn depressed block class="accent mt-3" v-if="loaded" @click="createPaymentMethod" :disabled="sending">
				<span v-if="!sending">Subscribe</span>
				<span v-if="sending">Wait a moment...</span>
			</v-btn>
        </form>
    </v-card>
</template>

<script>
import Subscription from '@/firebase/subscription'

export default {
  	data: () => ({
		sending: false,
		loaded: false,
        //stripe: Stripe('pk_test_KYTOODeedtqcJ29G1YWKqWCm00wnDN3hYF'),
        stripe: Stripe('pk_live_E4wZNtU8q9fgnrlSZGHMF11300ossTG5a9'),
        elements: null,
		cardElement: null,
		customer: null,
        style: {
            base: {
                color: '#333333',//"#32325d",
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: '#777777'//"#aab7c4"
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            }
        }
    }),
    mounted() {
		this.$gtm.trackView('Checkout', '/checkout');
		this.elements = this.stripe.elements();
		this.cardElement = this.elements.create('card', { style: this.style });

        this.init();
	},
  	methods: {
        init() {
            Subscription.getSubscriber(this.$route.params.id)
                .then(response => {
                    if (response.status === true) {
                        this.customer = response.doc.data();
						this.customer.id = response.doc.id;
						this.loaded = true;
						this.setCardElement();
                    } else {
						this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                    }
                });
        },
        setCardElement() {
            this.cardElement.mount(this.$refs['cardelement']);
            this.cardElement.on('change', this.showCardError);
        },
        showCardError(event) {
            let displayError = this.$refs['carderrors'];

            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
		},
		createPaymentMethod() {
			this.sending = true;
			this.stripe.createPaymentMethod({
						type: 'card',
						card: this.cardElement,
					})
					.then(result => {
						if (result.error) {
							//this.displayError(error);
							this.$store.dispatch('setSnack', {kind:'error', text:error});
						} else {
							this.createSubscription({
								customerId: this.customer.id,
								paymentMethodId: result.paymentMethod.id,
								name: this.customer.name,
								email: this.customer.email,
								parentName: this.customer.parentName,
								parentEmail: this.customer.parentEmail
							});
						}
					});
		},
		createSubscription(obj) {
			Subscription.createSubscription(obj)
				.then(response => {
					if (response.status === true) {
						if (response.content.status == 'active') {
							this.$router.push('/cart/success-subscription/'+this.customer.id);
						}
					} else {
						this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
					}
				});
		}
    }
}
</script>

<style scoped>
    .camp {
        border-radius: 5px !important;
        background-color: #EEEEEE !important;
    }
</style>